/**
 *获取用户信息
 *
 * @export
 * @returns
 */
export function getInfos() {
  return new Promise(resolve => {
    // 初始化全局存储变量appLocals
    if (!window.hasOwnProperty('appLocals') || !window.appLocals) {
      window.appLocals = Object.create(null);
    }
    window.__ksStorage__.docInit({
      // 中文地址（非必填，不传该参数时打开的是文档弹层首页）
      indexUrl: '//docs.ksyun.com/products/90',
      // 英文地址（非必填，不传该参数时打开的是文档弹层首页）
      // indexEnUrl:'//endocs.ksyun.com/products/47',
      // 设置文档的z-index，（非必填，不传该参数时默认是2000）
      zIndex: 10000
    });
    // 获取用户登录信息
    window.__ksStorage__.getBaseInfo('userInfo', data => {
      window.appLocals.userInfo = data;

      // 获取数据中心
      window.__ksStorage__.getValue('region', (key, value) => {
        window.appLocals.regionKey = value;

        resolve(true);
      });
    });
  });
}
export const TASK_STATUS = {
  QUEUING: '排队中',
  RUNNING: '运行中',
  FAILED: '错误终止',
  CANCELED: '已中断',
  FINISHED: '已完成'
};
export const TASK_STATUS_CLASS = {
  QUEUING: 'status-pending',
  RUNNING: 'status-running',
  FAILED: 'status-failed',
  CANCELED: 'status-canceled',
  FINISHED: 'status-completed'
};
export const TASK_FINISHED = ['FAILED', 'CANCELED', 'FINISHED'];
export const TASK_WAITING_RESULT = ['QUEUING', 'RUNNING'];
export const DISABLE_MENU_ROUTER = ['noAuth', 'error'];
export const CODE_OPTION = {
  minimap: { enabled: false },
  wordWrap: 'on',
  lineNumbers: false
};
// 提交中  排队中  运行中  错误终止  任务中断  已完成
// let serviceName = 'kqes'
// let roleNames = 'KsyunKQESDefaultRole'
// let redirectUrl = encodeURIComponent('https://kqes.console.ksyun.com')
// let AUTH_ADDRESS = `https://uc.console.ksyun.com/pro/iam/#/role/authorize?serviceName=${serviceName}&roleNames=${roleNames}&redirectUrl=${redirectUrl}`
//  // https://uc.console.ksyun.com/pro/iam/#/role/authorize?serviceName=kqes&roleNames=KsyunKQESDefaultRole&redirectUrl=https%3A%2F%2Fkqes.console.ksyun.com
// console.log(AUTH_ADDRESS)
